import { gtmEvent } from '../../../utils/gtmEvents';
const toggleGtmEvent = ({ event, paymentMethod, availabilityFlag }) => {
    gtmEvent({
        event,
        payment_option: paymentMethod,
        availability_flag: availabilityFlag,
    });
};
export default toggleGtmEvent;
